import * as React from "react";
import { useCallback, useState } from "react";
import { VPUITheme } from "../../../common/theme/vpui-theme";
import { RemotePrinterContextProvider } from "../../context/printer-context/remote-printer-context";
import { t } from "i18next";
import { AppBar, Button, ThemeProvider, Toolbar } from "@mui/material";
import { AppContextProvider } from "../../context/app-context/app-context";
import { Keyboard } from "@mui/icons-material";
import { QRLoginScanner } from "./qr-login-scanner";
import { LoginSuccessPrompt } from "./login-success-prompt";

import "./styles.scss";

interface IScanShipLoginComponentProps {
    onChangeLoginMode: () => void;
}

export const ScanShipLoginComponent = (props: IScanShipLoginComponentProps) => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [loggedInUserName, setLoggedInUserName] = useState<string | undefined>(undefined);

    const handleUserLoginSuccess = useCallback((userName: string) => {
        setIsSuccess(true);
        setLoggedInUserName(userName);
    }, []);

    return <ThemeProvider theme={VPUITheme}>
        <div className={"scan-and-ship"}>
            <AppContextProvider>
                <RemotePrinterContextProvider>
                    {isSuccess && loggedInUserName ?
                        <LoginSuccessPrompt userName={loggedInUserName} /> :
                        <QRLoginScanner onSuccess={handleUserLoginSuccess} />}
                    <AppBar position={"static"} elevation={0} className={"nav"} >
                        <Toolbar className={"nav__toolbar"}>
                            <div className={"nav__toolbar-item"}>
                                <Button onClick={() => props.onChangeLoginMode()}
                                        className={"nav__toolbar-button"}
                                        startIcon={<Keyboard />}>
                                    {t("login.label.keyboardLogin")}
                                </Button>
                            </div>
                        </Toolbar>
                    </AppBar>
                </ RemotePrinterContextProvider>
            </AppContextProvider>
        </div>
    </ThemeProvider>;
};
